import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../../../../models/UiUtils';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { CssSelectors } from '../../../../../../../web/styles/styles';

const { spacing, common, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	rsvpForm: {
		maxWidth: 1024,
		width: '100%',
		position: 'relative',
	},
	rsvpInfo: {
		'@media only screen and (min-width: 1024px)': {
			flexDirection: 'row',
			justifyContent: 'space-between',
			margin: '24px auto 0',
			width: '100%',
			gap: 24,
			...CssSelectors.allChildren(
				{
					width: '100%',
				},
				'div'
			),
		},

		display: 'flex',
		flexDirection: 'column',
		marginTop: 12,
		paddingTop: 12,
	},
	formControl: {
		'@media only screen and (min-width: 1024px)': {
			maxWidth: '33%',
		},
		marginBottom: spacing.md,
		textAlign: 'left',
		width: '100%',
		...CssSelectors.allChildren(
			{
				color: colors.text.main,
				fontSize: typography.fontSizes.xs,
			},
			'small'
		),
	},
	formControlFullWidth: {
		marginBottom: spacing.md,
		textAlign: 'left',
		width: '100%',
	},
	label: {
		color: colors.text.main,
		display: 'block',
		fontSize: typography.fontSizes.sm,
		margin: `0 0 ${spacing.xs}px`,
		textAlign: 'left',
	},
	requiredAsterisk: {
		color: colors.danger.main,
	},
	addAnotherGuestButton: {
		color: colors.hover.main,
		margin: `0 0 ${spacing.xs}px`,
	},
	removeGuestIcon: {
		verticalAlign: 'middle',
	},
	noMargin: {
		margin: 0,
	},
	errorMessage: {
		color: colors.danger.main,
	},
	guestInfoError: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginBottom: 6,
	},
	rsvpOptions: {
		'@media only screen and (min-width: 768px)': {
			flexDirection: 'row',
			margin: `${spacing.lg}px auto ${spacing.lg}px`,
			maxWidth: 1024,
		},
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 0,
		marginRight: 0,
		marginTop: spacing.lg,
		marginBottom: spacing.lg,
		padding: spacing.md,
		borderRadius: common.borderRadius,
	},
	radio: {
		':not(:last-child)': {
			margin: '0 0 12px 0',
		},
		'@media only screen and (min-width: 768px)': {
			':not(:last-child)': {
				margin: '0 12px 0 0',
			},
			margin: 0,
		},
		'@media only screen and (min-width: 1024px)': {
			':not(:last-child)': {
				margin: '0 90px 0 0',
			},
			margin: 0,
		},
	},
	plusOneOptionWrap: {
		'@media only screen and (min-width: 1024px)': {
			margin: '24px auto 0',
			width: '100%',
		},
		display: 'flex',
		flexDirection: 'column',
		marginTop: spacing.lg,
	},
	checkbox: {
		gap: 8,
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
	},
	actions: {
		width: '100%',
	},
	buttonContainer: {
		display: 'inline-flex',
		marginBottom: spacing.xl,
		marginTop: spacing.lg,
		gap: spacing.sm,
	},
	divider: {
		maxWidth: 1024,
		width: '100%',
		borderTop: `2px solid ${colors.border.main}`,
	},
	guestInfo: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.lg,
		alignItems: 'center',
	},
	disabledGuestInfo: {
		opacity: 0.5,
	},
	bringingGuestsLabel: {
		marginLeft: 6,
	},
	textInput: {
		width: '100%',
		boxSizing: 'border-box',
	},
	textArea: {
		height: 68,
	},
	selectBoxtriggerButton: {
		border: `1px solid ${colors.border.main}`,
		background: hexToRGBA(colors.border.main, 0.3),
		borderRadius: common.borderRadius,
	},
	required: {
		color: colors.danger.main,
	},
	paymentInfoTitle: {
		color: colors.text.main,
		margin: `0 0 ${spacing.md}px`,
	},
	orderInfo: {
		color: colors.text.main,
		...CssSelectors.allDescendants(
			{
				color: colors.text.main,
			},
			'strong'
		),
	},
	paymentInfo: {
		display: 'flex',
		flexDirection: 'column',
		textAlign: 'left',
		paddingBottom: spacing.md,
		boxSizing: 'border-box',
		...CssSelectors.allDescendants(
			{
				marginBottom: spacing.md,
				color: colors.text.main,
				margin: 0,
			},
			'p'
		),
		...CssSelectors.allChildren(
			{
				marginTop: spacing.lg,
				paddingBottom: spacing.md,
			},
			'div'
		),
		...CssSelectors.allDescendants(
			{
				color: colors.text.main,
			},
			'strong'
		),
	},
	paymentInfoText: {
		color: colors.border.main,
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				fontSize: typography.fontSizes.sm,
			},
			'span'
		),
		...CssSelectors.allChildren(
			{
				color: colors.text.main,
				fontSize: typography.fontSizes.md,
				display: 'block',
			},
			'strong'
		),
	},
	ticketCountText: {
		fontWeight: typography.fontWeights.standard,
	},
	modal: {
		...CssSelectors.allChildren(
			{
				background: hexToRGBA(colors.background.light, 0.4),
				...CssSelectors.allDescendants(
					{
						width: '100%',
						maxWidth: 400,
						boxSizing: 'border-box',
					},
					'.modal-overlay-content-after-open'
				),
			},
			'.modal-overlay-after-open'
		),
	},
	submitButton: {
		margin: '8px 0 8px',
		width: '100%',
	},
	formSubmitButton: {
		width: '100%',
		'@media only screen and (min-width: 768px)': {
			width: 155,
		},
	},
	paidTickets: {
		marginTop: spacing.md,
		marginBottom: spacing.md,
	},
	timesSymbol: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
	},
	warningMessage: {
		maxWidth: 370,
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		...CssSelectors.allDescendants(
			{
				color: colors.danger.main,
			},
			'span'
		),
	},
	closeButton: {
		position: 'absolute',
		top: 0,
		right: 0,
		fontSize: 0,
		width: 14,
		height: 14,
	},
	header: {
		position: 'relative',
	},
	// Ticket Selector Styles
	ticketSelectorContainer: {
		marginTop: spacing.lg,
		marginBottom: spacing.lg,
	},
	ticketSelectorHeading: {
		color: colors.primary.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.standard,
		marginBottom: spacing.md,
		marginTop: 0,
		textAlign: 'left',
	},
	ticketCards: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	ticketCard: {
		border: `1px solid ${colors.primary.main}`,
		borderRadius: common.borderRadius,
		padding: spacing.lg,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		backgroundColor: colors.background.light,
		position: 'relative',
		'@media only screen and (max-width: 768px)': {
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
	},
	ticketCardDisabled: {
		opacity: 0.6,
		backgroundColor: colors.border.light,
		borderColor: colors.border.main,
		pointerEvents: 'none',
		position: 'relative',
	},
	ticketCardLeft: {
		flex: 1,
		minWidth: 0,
	},
	ticketHeaderRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.sm,
		marginBottom: spacing.xs,
	},
	ticketName: {
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		color: colors.text.main,
		textAlign: 'left',
	},
	soldOutBadge: {
		display: 'flex',
		fontSize: typography.fontSizes.xl,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
		// backgroundColor: colors.danger.light,
		padding: `${spacing.xs / 2}px ${spacing.xs}px`,
		borderRadius: common.borderRadius,
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 1,
	},
	paidBadge: {
		display: 'inline-flex',
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		color: '#fff',
		backgroundColor: colors.success.main,
		padding: `${spacing.xs / 2}px ${spacing.xs}px`,
		borderRadius: common.borderRadius,
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
	},
	ticketPriceRow: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'baseline',
		marginBottom: spacing.xs,
	},
	priceAmount: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
	},
	taxNote: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
		whiteSpace: 'nowrap',
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: spacing.sm,
	},
	ticketDescription: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		margin: 0,
		textAlign: 'left',
		marginTop: spacing.sm,
	},
	ticketCardRight: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		'@media only screen and (max-width: 768px)': {
			marginTop: spacing.md,
			width: '100%',
			justifyContent: 'center',
		},
	},
	quantityButton: {
		width: 32,
		height: 32,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		backgroundColor: colors.background.light,
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'all 0.2s ease',
		':hover:not(:disabled)': {
			backgroundColor: colors.hover.main,
			borderColor: colors.border.main,
		},
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
	},
	quantityDisplay: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 74,
		height: 42,
		textAlign: 'center',
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.standard,
		color: colors.text.main,
		backgroundColor: colors.background.main,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		':focus': {
			outline: 'none',
			borderColor: colors.primary.main,
		},
	},
	// Ticket Holder Fields Styles
	ticketHolderContainer: {
		marginTop: spacing.lg,
		marginBottom: spacing.lg,
	},
	ticketHolderHeadingRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		marginBottom: spacing.xs,
	},
	ticketHolderHeading: {
		color: colors.primary.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.standard,
		marginBottom: 0,
		marginTop: 0,
		textAlign: 'left',
	},
	ticketHolderSubtext: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		marginTop: 0,
		marginBottom: spacing.md,
	},
	ticketHolderCards: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	ticketHolderCard: {
		borderTop: `1px solid ${colors.border.light}`,
		paddingTop: spacing.md,
		paddingBottom: spacing.md,
		backgroundColor: 'transparent',
	},
	ticketHolderCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		marginBottom: spacing.sm,
		flexDirection: 'column',
		gap: spacing.xs,
		'@media only screen and (max-width: 768px)': {
			alignItems: 'flex-start',
		},
	},
	ticketHolderCardTitle: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		color: colors.text.main,
		textAlign: 'left',
	},
	primaryTicketLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		cursor: 'pointer',
		userSelect: 'none',
	},
	primaryTicketRadio: {
		cursor: 'pointer',
		width: 16,
		height: 16,
		margin: 0,
	},
	primaryTicketText: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		fontWeight: typography.fontWeights.standard,
	},
	ticketHolderFields: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		gap: spacing.md,
		'@media only screen and (max-width: 1024px)': {
			gridTemplateColumns: 'repeat(2, 1fr)',
		},
		'@media only screen and (max-width: 768px)': {
			gridTemplateColumns: '1fr',
		},
	},
	ticketHolderFieldLabel: {
		color: colors.text.main,
		display: 'block',
		fontSize: typography.fontSizes.sm,
		margin: `0 0 ${spacing.xs}px`,
		textAlign: 'left',
		fontWeight: typography.fontWeights.standard,
	},
	// Payment Polling Styles
	pollingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: spacing.xl,
		marginTop: spacing.lg,
		marginBottom: spacing.lg,
		backgroundColor: hexToRGBA(colors.info.main, 0.1),
		border: `2px solid ${colors.info.main}`,
		borderRadius: common.borderRadius,
		textAlign: 'center',
	},
	pollingMessage: {
		fontSize: typography.fontSizes.md,
		color: colors.text.main,
		marginTop: spacing.md,
		marginBottom: spacing.xs,
	},
	pollingWarning: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
		marginTop: spacing.xs,
		marginBottom: 0,
		maxWidth: 400,
	},
	// Form submission loading overlay
	submitOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: colors.background.light,
		opacity: 0.95,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 1000,
		gap: spacing.md,
	},
	submitOverlayText: {
		fontSize: typography.fontSizes.md,
		color: colors.text.main,
		marginTop: spacing.md,
	},
});
